export default __webpack_public_path__ + "static/media/data-mining-selected.82c667fa.svg";